import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from 'src/app/models/table-column.model';
import { LoadingService } from 'src/app/services/loading.service';
import { Router } from '@angular/router';
import { RegistrationLinkService } from 'src/app/services/registration-link.service';
import { RegistrationLinkModel } from 'src/app/models/registration-link/registration-link.model';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { PageStateFlags } from 'src/app/constants/page-state.constants';
import { PageStateService } from 'src/app/services/page-state.service';

@Component({
  selector: 'app-registration-overview',
  templateUrl: './registration-links-overview.component.html',
  styleUrl: './registration-links-overview.component.scss',
  standalone: false
})
export class RegistrationLinksOverviewComponent {
  allRegistrationLinks: RegistrationLinkModel[] = [];

  columns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      cssClass: 'width-150',
    },
     {
      caption: this.translateService.instant('COMMON.FIELDS.DESCRIPTION'),
      dataField: 'description',
      disableFiltering: true,
      cssClass: 'width-150',
    },
    {
      caption: '',
      dataField: 'this',
      cellType: 'action',
      disableFiltering: true,
      cellTemplate: 'actionsTemplate',
      actions: [
        {
          icon: 'copy',
          isShowAction: () => true,
          onClick: (registrationLink: RegistrationLinkModel, e: any): void => {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            this.copyRegistrationLink(registrationLink.key);
          },
        },
        {
          icon: 'link-tab',
          isShowAction: () => true,
          onClick: (registrationLink: RegistrationLinkModel, e: any): void => {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            this.navigateToRegistrationLinkNewTab(registrationLink.id);
          },
        },
      ],
    },
  ];

  readonly stateKey: string = 'registration-links-overview';

  constructor(
    private registrationLinkService: RegistrationLinkService,
    private translateService: TranslateService,
    private loadingService: LoadingService,
    private router: Router,
    private clipboard: Clipboard,
    private toastrService: ToastrService,
    private pageStateService: PageStateService
  ) {
    this.loadRegistrationLinks();
  }

  ngOnInit() {
    if (!this.pageStateService.consumeFlag(
      PageStateFlags.RestoreRegistrationLinksOverview
    )) {
      this.pageStateService.clear(this.stateKey);
    }
  }

  loadRegistrationLinks() {
    this.loadingService.load(
      this.registrationLinkService.getAllRegistrationLinks()
    )
      .subscribe((allRegistrationLinks) => {
        this.allRegistrationLinks = allRegistrationLinks;
      });
  }

  navigateToRegistrationLinkNewTab(id: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['registration-links', id])
    );
    window.open(url, '_blank');
  }

  navigateToRegistrationLink(id?: string) {
    if(id) {
      this.router.navigate(['registration-links', id]);
    } else {
      this.navigateToNewRegistrationLink();
    }
  }

  navigateToNewRegistrationLink() {
    this.router.navigate(['registration-links', 'edit', 'new']);
  }

  copyRegistrationLink(key: string) {
    const url =
      window.location.origin +
      environment.registerBaseUrl +
      '/' + key;

    if (this.clipboard.copy(url)) {
      this.toastrService.success(
        this.translateService.instant("COPY-LINK.COPY-SUCCESS")
      );
    } else {
      this.toastrService.warning(
        this.translateService.instant("COPY-LINK.COPY-FAILURE")
      );
    }
  }
}
